setInterval(function () {
  var threshold_p = window.bundle_settings.bundle_threshold_price;
  var p = $("[data-v-c13c94][data-v-7053f9]"),
    v = p.text()?.split(" "),
    rp = $("[data-v-c13c94][data-v-bf4ab4]"),
    rv = rp.text()?.split(" ");
  // console.log(p, rp, v, rv);
  $(".min_text").remove();
  if (p.length) {
    let tp = extractNumericValue(v[v.length - 1]);
    if (tp >= threshold_p) {
      $("button[data-v-7053f9-s], button[data-v-c0bcd8-s]").prop(
        "disabled",
        false
      );
    } else {
      $("button[data-v-7053f9-s], button[data-v-c0bcd8-s]")
        .prop("disabled", true)
        .after(
          `<div class="min_text">${window.bundle_settings.bundle_threshold_mgs}</div>`
        );
    }
  }
  if (rp.length) {
    let rtp = extractNumericValue(rv[rv.length - 1]);
    if (rtp >= threshold_p) {
      $(".rb-subs-nav-btn").removeClass("tdisabled");
    } else {
      $(".rb-subs-nav-btn").addClass("tdisabled");
    }
  }
  let st = $(".ajax-cart__subtotal").attr("data-subs-subtotal"),
    threshold_p_cents = threshold_p * 100;
  // console.log((st >= threshold_p_cents), '<<<<<')
  if ($(".ajax-cart__selling-plan-name").length) {
    if (st >= threshold_p_cents) {
      $('[name="checkout"], .cart__checkout-container').removeClass("disabled");
      $(".checkout_msg").hide();
    } else {
      $('[name="checkout"], .cart__checkout-container').addClass("disabled");
      $(".checkout_msg").show();
    }
  } else {
    $('[name="checkout"], .cart__checkout-container').removeClass("disabled");
    $(".checkout_msg").hide();
  }
}, 100);
function extractNumericValue(priceString) {
  var numericPart = priceString.match(/[0-9.]+/);
  if (numericPart) {
    return parseFloat(numericPart[0]);
  } else {
    return 0;
  }
}
